import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ExperimentationProvider } from '@americanexpress/enterprise-experimentation';
import { isStatsigEnabled } from '../utils';

export const StatSig = ({
  locale, pathname, tier, children,
}) => {
  if (isStatsigEnabled({ locale, pathname })) {
    return (
      <ExperimentationProvider
        targetApp="us-eapply-node"
        clientKey="client-iUJBSxdH5x0uRVr69lEbeP8iySjjGtoaODCVt6X94VR"
        options={{ environment: { tier } }}
      >
        {children}
      </ExperimentationProvider>
    );
  }
  return children;
};

StatSig.propTypes = {
  locale: PropTypes.string,
  pathname: PropTypes.string,
  tier: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export const mapStateToProps = (state) => ({
  tier: state.getIn(['config', 'statsigTier']),
});

export default connect(mapStateToProps)(StatSig);
